<template>
  <div class="content-wrapper">
    <div class="toast-wrapper">
      <transition name="slide-fade">
        <div class="notification is-warning" v-if="showMessage">
          {{ toastMessage }}
        </div>
      </transition>
    </div>
    <form class="form-group" id="form" v-on:submit.prevent="addRating">
      <p class="control" v-show="editName">
        <input class="input is-medium input-name" type="text" v-model="rateData.name" placeholder="Vad är ditt namn?" v-on:blur="toggleEditName" id="editName" autofocus>
      </p>
      <p class="control has-text-centered" v-show="!editName">
        <label class="rater-name" v-on:click="toggleEditName" for="editName">
          <strong>{{ rateData.name }}</strong>, snart dags för öl!
          <i class="fa fa-edit"></i>
        </label>
      </p>
      <p class="control">
        <span class="select is-medium">
          <select v-model="rateData.beer" class="select-beer">
            <option value="" disabled>Välj en öl ...</option>
            <option v-for="beer in beers" v-bind:value="beer.id">{{ beer.name }}</option>
          </select>
        </span>
      </p>
      <div class="range-wrapper">
        <range-slider
          class="range-input"
          min="0"
          max="20"
          step="1"
          v-model="sliderValue">
        </range-slider>
        <output id="rangeInfo" class="range-output" v-text="total" />
      </div>
      <p class="control"></p>
      <p class="control">
        <input type="submit" :disabled="!isValid" class="button is-primary is-large"  value="Sätt betyget ..." v-on:click="flashMessage">
      </p>

    </form>
    <ul class="latest-beers">
      <li class="beer-item" v-for="beer in bestBeers">
        <span class="average">{{ beer.average }}</span> - {{ beer.name }}</li>
    </ul>
  </div>
</template>

<script>
import RangeSlider from 'vue-range-slider'
// you probably need to import built-in style
import 'vue-range-slider/dist/vue-range-slider.css'
import myMixin from 'mixins'
import _ from 'lodash'

export default {
  name: 'rating',
  components: {RangeSlider},
  mixins: [myMixin],
  data () {
    return {
      rateData: {
        name: '',
        rating: 0,
        beer: ''
      },
      editName: false,
      sliderValue: 0,
      showMessage: false,
      toastMessage: '',
      toastQuotes: [
        'What are you waiting for! Christmas?',
        'Satan comes to thoose who wait',
        'In go we trust with beer we rule!'
      ]
    }
  },
  computed: {
    validation: function () {
      return {
        name: !!this.rateData.name.trim()
      }
    },
    total: function () {
      return this.sliderValue / 4
    },
    isValid: function () {
      let name = this.rateData.name
      let beer = this.rateData.beer

      if (name.length > 0 && beer !== '') {
        return true
      }

      return false
    },
    beers: function () {
      return this.$store.getters.rateBeers
    },
    bestBeers: function () {
      return _.orderBy(this.$store.getters.rateBeers, 'average', 'desc')
    }
  },
  // methods
  methods: {
    addRating: function () {
      if (this.isValid) {
        // Get slider value
        this.rateData.rating = this.total
        this.rateData.dateKey = this.$store.getters.dateKey

        // Save rating to Firebase
        this.$store.dispatch('addRating', this.rateData)

        // Reset values
        this.sliderValue = 0
        this.rateData.beer = ''

        // Set name to store
        this.$store.dispatch('setRaterName', this.rateData.name)
        this.setCookie('3ol3', 'userName=' + this.rateData.name, 666)
      }
    },
    flashMessage () {
      this.showMessage = !this.showMessage
      let self = this

      let numQuotes = this.toastQuotes.length
      let rand = Math.floor(Math.random() * numQuotes)
      this.toastMessage = this.toastQuotes[rand]

      setTimeout(function () {
        self.showMessage = !self.showMessage
      }, 2000)
    },
    toggleEditName () {
      if (this.rateData.name === '') {
        this.editName = true
      } else {
        this.editName = !this.editName
      }
    }
  },
  mounted () {
    if (this.$store.getters.raterName) {
      this.rateData.name = this.$store.getters.raterName
    } else if (this.getCookie('userName')) {
      this.rateData.name = this.getCookie('userName')
      this.$store.dispatch('setRaterName', this.getCookie('userName'))
    } else {
      this.editName = true
    }
  }
}
</script>

<style lang="scss">
@import '~vue-range-slider/dist/vue-range-slider.scss';
@import '../assets/styles/config.scss';
  .control.has-text-centered {
    text-align: center;
  }
  .rater-name {
    font-size: 1.375em;
  }
  .latest-beers {
    padding: 0 20px;

    .beer-item {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .input.input-name {
    border: 0;
    font-weight: 900;
    text-align: center;

    &:focus {
      background-color: #fff;
      border: 1px solid #dbdbdb;
      color: #000;
      font-weight: normal;
      text-align: left;
    }

    &:after {
      content: "! Kul att se dig ...";
      color: #444035
    }
  }
  .fa-edit:before {
    font-size: 0.666666667em;
    color: #e2e2e2;
  }
  .button {
    width: 100%
  }
  .content-wrapper {
    position: relative;
    padding: 20px 0;

    .notification {
      position: absolute;
      top: 20px;
      z-index: 1;
      left: 50%;
      transform: translateX(-50%);
      width: 355px;
    }
  }
  .select {
    width: 100%;

    .select-beer {
      width: 100%;
    }
  }
  .range-wrapper {
    background-color: $color_light;
    border-radius: 3px;
    border: 1px solid $color_dark;
    margin-right: 12px;
    padding: 11px 50px 6px 12px;
    position: relative;

    .range-slider-fill {
      background-color: $color_accent;
    }

    .range-input {
      width: 100%;
    }

    .range-slider-knob {
      background-color: $color_accent;
      background-image: url('../assets/slider-knob.png');
      background-position: 4px 0px;
      background-repeat: no-repeat;
      background-size: contain;
      border: 3px solid $color_accent;
      height: 25px;
      width: 25px;
    }
  }

  .range-output {
    background-color: #fff;
    border-radius: 50%;
    border: 1px solid $color_dark;
    font-weight: bold;
    height: 50px;
    line-height: 1;
    padding-top: 16px;
    position: absolute;
    right: -14px;
    text-align: center;
    top: -4px;
    width: 50px;
  }
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active for <2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// Rating.vue?47ce2a72